import React from 'react';
import { Carousel, Image } from 'antd';
import styles from './viewStand.module.scss';

const CustomCarousel = ({images, alt}) => {

  const { img } = styles;
  
  return (
    <Carousel
      autoplay
      dots={false}
      effect='fade'
    >
      {images.map((image, i) => {
        return(
          <Image preview={false} key={i} src={image} alt={alt} className={img}/>
        );
      })}
    </Carousel>
  );
};

export default CustomCarousel;